const updates = [
  { title: '《斗破苍穹》第1382话「终极对决」已更新', time: '10分钟前', tag: '最新', tagColor: 'bg-primary-500' },
  { title: '《海贼王》第1124话「觉醒之时」已更新', time: '28分钟前', tag: '热门', tagColor: 'bg-accent-500' },
  { title: '《一人之下》第687话「真相浮现」已更新', time: '1小时前', tag: '追更', tagColor: 'bg-secondary-500' },
  { title: '《狐妖小红娘》第426话「前缘再续」已更新', time: '2小时前', tag: '连载', tagColor: 'bg-primary-500' },
  { title: '《咒术回战》第271话「终局之战」已更新', time: '3小时前', tag: '热门', tagColor: 'bg-accent-500' },
  { title: '《镇魂街》第398话「守护之魂」已更新', time: '5小时前', tag: '追更', tagColor: 'bg-secondary-500' },
  { title: '《间谍过家家》第112话「家庭旅行」已更新', time: '7小时前', tag: '连载', tagColor: 'bg-primary-500' },
  { title: '《鬼灭之刃·外传》特别篇「水之呼吸」已更新', time: '9小时前', tag: '特别', tagColor: 'bg-accent-500' },
  { title: '《排球少年·Next》番外篇「新的开始」已更新', time: '12小时前', tag: '新番', tagColor: 'bg-secondary-500' },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="w-full py-14 md:py-20">
      <div className="w-full max-w-[860px] mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">追更动态</h2>
          <p className="text-sm text-foreground-500">实时掌握<strong>免费漫画资源</strong>最新更新，追更不迷路</p>
        </div>
        <div className="relative">
          <div className="absolute left-4 md:left-6 top-0 bottom-0 w-px bg-primary-200"></div>
          <div className="flex flex-col gap-0">
            {updates.map((update, idx) => (
              <a
                key={idx}
                href="#ranking"
                className="relative flex items-start gap-4 md:gap-6 pl-10 md:pl-14 py-4 group cursor-pointer"
              >
                <div className="absolute left-2.5 md:left-[18px] top-5 w-3 h-3 rounded-full bg-primary-500 border-2 border-background-50 group-hover:scale-125 transition-transform"></div>
                <div className="flex-1 min-w-0 bg-background-50 rounded-lg border border-background-200/60 px-4 py-3 md:px-5 md:py-3.5 group-hover:border-primary-200 transition-colors">
                  <div className="flex items-start justify-between gap-3 flex-wrap">
                    <p className="text-sm md:text-base text-foreground-800 leading-relaxed flex-1">{update.title}</p>
                    <span className={`inline-block px-2.5 py-0.5 text-xs font-medium rounded-full text-background-50 whitespace-nowrap flex-shrink-0 ${update.tagColor}`}>{update.tag}</span>
                  </div>
                  <p className="text-xs text-foreground-400 mt-2">{update.time}</p>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}